import React, { useState, useEffect } from 'react';


export default function ProgressBar({ textinside, now, variant, classname, ...props }) {

    classname = classname ? ' ' + classname : '';
    variant = variant ? ' progress--' + variant : '';
    classname += textinside ? ' progress--textinside' : '';

    return (
        <div className={'progress'+classname+variant} {...props}>
            <div className="progress__text">{ now }%</div>
            <div className="progress__bar">
                <div className="progress__value" style={{ width: now+'%' }}></div>
            </div>
        </div>
    )
}